import { render } from "./TherapyCollection.vue?vue&type=template&id=30aebe70&scoped=true"
import script from "./TherapyCollection.vue?vue&type=script&lang=js"
export * from "./TherapyCollection.vue?vue&type=script&lang=js"

import "./TherapyCollection.vue?vue&type=style&index=0&id=30aebe70&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30aebe70"]])

export default __exports__